import { Flex, Heading, Text } from "@chakra-ui/react";
const HotMintsTitle = () => {
  return (
    <Flex direction="column" justify="center" align="center" gap="1rem" py="1rem">
      <Heading fontSize="5xl">🔥 Hot Mints</Heading>
      <Text textAlign="center">Catch them while they're hot off the blockchain</Text>
    </Flex>
  );
};

export default HotMintsTitle;

